import { render, staticRenderFns } from "./AccountInfoPopup.vue?vue&type=template&id=be266a76"
import script from "./AccountInfoPopup.vue?vue&type=script&lang=js"
export * from "./AccountInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./AccountInfoPopup.vue?vue&type=style&index=0&id=be266a76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports